export const GET_LEGAL_CHANGES = 'GET_LEGAL_CHANGES'
export const SET_LEGAL_CHANGES = 'SET_LEGAL_CHANGES'
export const SET_NEW_LEGAL_CHANGES = 'SET_NEW_LEGAL_CHANGES'
export const GET_LEGAL_CHANGES_ERROR = 'GET_LEGAL_CHANGES_ERROR'
export const RESET_LEGAL_CHANGES = 'RESET_LEGAL_CHANGES'
export const SET_LEGAL_CHANGE_FILTERS = 'SET_LEGAL_CHANGE_FILTERS'
export const RESET_LEGAL_CHANGE_FILTERS = 'RESET_LEGAL_CHANGE_FILTERS'
